import React from 'react';
import { Link } from 'react-router-dom';
import { FaServer, FaUsers, FaShieldAlt } from 'react-icons/fa';
import '../styles/EnterprisePage.css';

const EnterprisePage = () => {

  return (
    <div className="enterprise-page">
      <section className="enterprise-hero">
        <div className="container">
          <h1>Dubbah for Enterprise</h1>
          <p>Integrate automated dubbing into your own platform or workflow. Self-hosted, API access, volume licensing, and custom deployments.</p>
        </div>
      </section>

      <section className="enterprise-features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaServer /></div>
              <h3>Self-Hosted Deployment</h3>
              <p>Run the full dubbing pipeline on your own infrastructure. Your content is never sent to external servers or used to train models.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaUsers /></div>
              <h3>Volume Licensing</h3>
              <p>Deploy Dubbah across your team or organization with flexible seat-based licensing.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaShieldAlt /></div>
              <h3>Custom Integrations</h3>
              <p>Plug Dubbah's dubbing engine into your existing content pipeline via API or custom builds.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="enterprise-cta">
        <div className="container">
          <h2>Let's Talk</h2>
          <p>Tell us about your use case and we'll figure out the right setup together.</p>
          <Link to="/contact" className="primary-button">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default EnterprisePage;
